import { defineStore } from "pinia";
import { checkAuth, chooseCity, getCities, getUserData } from "../auth";
import cookiesService from "../cookiesService";

const modalInitialValue = {
  show: false,
  type: null,
  data: null,
};

const secondaryModalInitialValue = {
  show: false,
  type: null,
  data: null,
};

const menuStatusBadgesInitial = () => ({
  hasUnsignedAny: null,
  hasOpenEmployeeTasks: null,
  closingDocumentsCount: null,
});

const initialValue = {
  init: false,
  auth: false,
  keycloakError: null,
  userData: null,
  cities: [],
  menuDrawerOpen: true,
  modal: modalInitialValue,
  secondaryModal: secondaryModalInitialValue,
  menuStatusBadges: menuStatusBadgesInitial(),
};
const cookiesServiceInstance = cookiesService.getService();
export const useAppStore = defineStore("app", {
  state: () => ({
    ...initialValue,
  }),
  getters: {
    isInit: (s) => !!s.init,
  },
  actions: {
    setInit() {
      this.init = true;
    },
    setKeycloakError(message) {
      this.keycloakError = message;
    },
    clearKeycloakError() {
      this.keycloakError = null;
    },
    setAuth() {
      this.auth = true;
    },
    setUserData(res) {
      this.userData = res;
    },
    showModal(type, data) {
      this.modal = {
        show: true,
        type,
        data: data || {},
      };
    },
    changeModalTitle(title) {
      this.modal = {
        ...this.modal,
        data: this.modal.data ? { ...this.modal.data, title } : { title },
      };
    },
    closeModal() {
      this.modal = modalInitialValue;
    },
    showSecondaryModal(type, data) {
      this.secondaryModal = {
        show: true,
        type,
        data: data || {},
      };
    },
    closeSecondaryModal() {
      this.secondaryModal = secondaryModalInitialValue;
    },
    changeSecondaryModalTitle(title) {
      this.secondaryModal = {
        ...this.secondaryModal,
        data: this.secondaryModal.data
          ? { ...this.secondaryModal.data, title }
          : { title },
      };
    },
    toggleMenuDrawer() {
      this.menuDrawerOpen = !this.menuDrawerOpen;
    },
    async getUserData() {
      if (this.userData) return;
      const res = await getUserData();
      if (res) this.setUserData(res);
    },
    async getCitiesData() {
      if (this.cities?.length) return;
      const res = await getCities();
      this.cities = res || [];
    },
    async chooseCityData(city_id) {
      const res = await chooseCity(city_id);
      if (res) {
        if (!this.userData) this.userData = res;
        else this.userData = { ...this.userData, ...res };
        window.location.reload();
      }
    },
    async initialize() {
      const isAuth = await checkAuth();
      if (isAuth) this.auth = true;
      this.setInit();
    },
    resetStore() {
      this.userData = null;
      this.cities = [];
      this.menuStatusBadges = menuStatusBadgesInitial();
    },
    setMenuStatusBadges(payload) {
      if (!payload) return;
      this.menuStatusBadges = {
        hasUnsignedAny: !!payload.has_unsigned_any,
        hasOpenEmployeeTasks: !!payload.has_open_employee_tasks,
        closingDocumentsCount: payload.closing_documents_count ?? null,
      };
    },
    setClosingDocumentsCount(count) {
      this.menuStatusBadges = {
        ...this.menuStatusBadges,
        closingDocumentsCount: count ?? null,
      };
    },
    logout() {
      cookiesServiceInstance.clearToken();
      this.auth = false;
      this.resetStore();
    },
  },
});
